import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem, IconButton, Typography, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FaBars, FaTimes } from 'react-icons/fa';
import logo from '../../../assets/images/logo.png';
import 'flag-icons/css/flag-icons.min.css';
import Nav from '../nav/Nav';
import './Navbar.css';

function Navbar() {
  const { t, i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem('language') || i18n.language
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('language')) {
      i18n.changeLanguage(localStorage.getItem('language'));
    }
  }, []);

  // Ferme le menu si on redimensionne au-dessus de 767px
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 767) setIsMenuOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLanguageChange = (lang) => {
    setSelectedLanguage(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
    setAnchorEl(null);
  };

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const getFlagClassName = (language) => {
    switch (language) {
      case 'en': return 'fi fi-gb';
      case 'fr': return 'fi fi-fr';
      case 'de': return 'fi fi-de';
      case 'esp': return 'fi fi-es';
      case 'ar': return 'fi fi-sa';
      case 'port': return 'fi fi-pt';
      default: return '';
    }
  };

  const getLanguageName = (language) => {
    switch (language) {
      case 'en': return 'English';
      case 'fr': return 'Français';
      case 'de': return 'Deutsch';
      case 'esp': return 'Español';
      case 'ar': return 'العربية';
      case 'port': return 'Português';
      default: return '';
    }
  };

  return (
    <section>
      <nav className="navbar" style={{ direction: 'ltr' }}>
        <div className="navbar-inner container">

          {/* ── Logo ── */}
          <NavLink className="navbar-brand" to="/">
            <img alt="logo" className="img-fluid" src={logo} width="150" />
          </NavLink>

          {/* ── Desktop : liens centre ── */}
          <Box className="nav-desktop">
            <Nav closeMenu={() => setIsMenuOpen(false)} />
          </Box>

          {/* ── Droite : langue + hamburger ── */}
          <Box className="navbar-right">

            {/* Sélecteur de langue — toujours visible */}
            <IconButton
              color="inherit"
              onClick={handleClick}
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <span className={getFlagClassName(selectedLanguage)} style={{ marginRight: 6 }} />
              <Typography variant="body1" sx={{ fontSize: '14px' }}>
                {getLanguageName(selectedLanguage)}
              </Typography>
              <ExpandMoreIcon style={{ marginLeft: 4, fontSize: '18px' }} />
            </IconButton>

            {/* Hamburger — visible seulement sur mobile */}
            <IconButton
              className="hamburger-btn"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              sx={{ color: '#fff', display: { xs: 'flex', md: 'none' } }}
            >
              {isMenuOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
            </IconButton>
          </Box>

          {/* Menu dropdown langue */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <MenuItem onClick={() => handleLanguageChange('en')}><span className="fi fi-gb" style={{ marginRight: 10 }} /> English</MenuItem>
            <MenuItem onClick={() => handleLanguageChange('fr')}><span className="fi fi-fr" style={{ marginRight: 10 }} /> Français</MenuItem>
            <MenuItem onClick={() => handleLanguageChange('de')}><span className="fi fi-de" style={{ marginRight: 10 }} /> Deutsch</MenuItem>
            <MenuItem onClick={() => handleLanguageChange('esp')}><span className="fi fi-es" style={{ marginRight: 10 }} /> Español</MenuItem>
            <MenuItem onClick={() => handleLanguageChange('ar')}><span className="fi fi-sa" style={{ marginRight: 10 }} /> العربية</MenuItem>
            <MenuItem onClick={() => handleLanguageChange('port')}><span className="fi fi-pt" style={{ marginRight: 10 }} /> Português</MenuItem>
          </Menu>
        </div>

        {/* ── Menu mobile déroulant ── */}
        {isMenuOpen && (
          <div className="mobile-menu">
            <Nav closeMenu={() => setIsMenuOpen(false)} />
          </div>
        )}
      </nav>
    </section>
  );
}

export default Navbar;